import React from 'react';
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import IconLoading from "images/icon-loading.gif";
import ClassDiploma from "./ClassDiploma";

export default function FacultyDiploma({ userProfile, myClasses = []}) {

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2rem"}}>
      {myClasses.filter(myClass => myClass.classType === "normal").map(myClass => {
        return (
          <ClassDiploma myClass={myClass} userProfile={userProfile} />
        )
      })}
    </div>
  )
}